import BulkActionReassign from './BulkActionReassign';

export default BulkActionReassign;
